import React from "react";

import Select from "react-select";

import { LineInput } from "components/Inputs/LineInput";
import AibleStep from "containers/CreateWizard/AibleStep";

import styles from "./style.module.css";

import "react-toggle/style.css";

export default class MiniCostsWaterfall extends React.PureComponent {
  renderCostsCheck() {
    const { hideCosts, updateHideCosts } = this.props;

    return (
      <div className={styles.costsCheck} onClick={() => updateHideCosts(!hideCosts)}>
        <input type="checkbox" checked={!hideCosts} onChange={() => {}} />
        {"Include soft benefits and costs"}
      </div>
    );
  }

  render() {
    const {
      id,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      currentROI,
      convergeError,
      truePositive,
      falsePositive,
      trueNegative,
      falseNegative,
      truePositiveLabel,
      falsePositiveLabel,
      trueNegativeLabel,
      falseNegativeLabel,
      defaultTruePositive,
      defaultFalsePositive,
      netImpactLabel,
      isShow,
      hideCosts,
      isHideCounts,
      options,
      outcome,
      success,
      timePeriod,
      updateTimePeriod,
      sucessOptions,
      updateFalsePositive,
      updateTruePositive,
      updateTrueNegative,
      updateFalseNegative,
      updateFalsePositiveLabel,
      updateTruePositiveLabel,
      updateTrueNegativeLabel,
      updateFalseNegativeLabel,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateIsHideCounts,
      updateNetImpactLabel
    } = this.props;
    const labelStyle = { width: "200px" };

    const waterfallBars = hideCosts
      ? [
          {
            label: truePositiveLabel,
            value: conversionGain * truePositive
          },
          {
            label: falsePositiveLabel,
            value: conversionCost * falsePositive
          }
        ]
      : [
          {
            label: truePositiveLabel,
            value: conversionGain * truePositive
          },
          {
            label: falsePositiveLabel,
            value: conversionCost * falsePositive
          },
          {
            label: trueNegativeLabel,
            value: conversionSaved * trueNegative
          },
          {
            label: falseNegativeLabel,
            value: conversionMissed * falseNegative
          }
        ];

    const isLocked = options && options["lock"];

    return (
      <div className={styles.body} style={{ opacity: isShow ? 1 : 0, paddingBottom: "0px" }}>
        <div className={styles.body} style={{ paddingBottom: "0px" }}>
          <AibleStep
            className={styles.costWaterfallCustom}
            id={id}
            bId="chooseTime"
            message={"What is the time period for which you would like to calculate your " + netImpactLabel + "?"}
            secondaryMessage={
              "This sets the time period that I will use to calculate the " +
              "Net Impact of deploying an AI and the Net Impact of your current state."
            }
            style={{ marginBottom: "0px" }}
            isBreak
          >
            <div className={styles.lFlex}>
              <div className={styles.centerLabel}>Time Period</div>

              <div style={{ width: "200px", marginRight: "auto" }}>
                {isLocked ? (
                  timePeriod
                ) : (
                  <Select
                    value={{ value: timePeriod, label: timePeriod }}
                    options={[
                      { label: "Day", value: "Day" },
                      { label: "Week", value: "Week" },
                      { label: "Month", value: "Month" },
                      { label: "Quarter", value: "Quarter" },
                      { label: "Year", value: "Year" }
                    ]}
                    onChange={(val) => updateTimePeriod(val.value)}
                    menuPlacement="top"
                  />
                )}
              </div>
            </div>
          </AibleStep>
        </div>
        <AibleStep
          id={id}
          bId={"costsWaterfall"}
          message={"With your current state process, what are the counts for each outcome per " + timePeriod + "?"}
          secondaryMessage={
            outcome && success
              ? "(Hint: In your dataset " +
                outcome +
                ": " +
                success +
                " occurs " +
                ((defaultTruePositive / (defaultTruePositive + defaultFalsePositive)) * 100).toFixed(2) +
                "% of the time)." +
                " I use these counts to calculate the Net Impact of your current process, " +
                "and to allow you to set your processing capacity. " +
                "The top two counts are typically things you correctly or incorrectly take action on today, " +
                "the bottom two counts are typically things you correctly or incorrectly don’t take action on today. "
              : undefined
          }
          isBreak={true}
          optionsHolder={false}
        />
        <div className={styles.outerHolder}>
          <div
            className={styles.holder + " " + (isHideCounts ? styles.hideHolder : "")}
            style={{ paddingLeft: "20px", paddingRight: "20px" }}
          >
            <div className={styles.leftCosts}>
              <div className={styles.costRow} style={{ height: "20px" }}>
                <div className={styles.rowShort}>{"Outcome"}</div>
                <div className={styles.countInputN}>{"Count"}</div>
                <div className={styles.costInputLabel}>{"Impact"}</div>
              </div>
              <div className={styles.costRow} style={hideCosts ? { height: "125px" } : {}}>
                <div className={styles.rowShort}>
                  <div className={styles.topLabel}>{truePositiveLabel}</div>
                </div>
                <div className={styles.countInput} id="truePositiveCount">
                  <LineInput
                    inputType="int"
                    value={truePositive}
                    onChange={(val) => updateTruePositive(val)}
                    borderColor={waterfallBars[0].color}
                    isBox
                    isLocked={isLocked}
                  />
                </div>
                {"×"}
                <div className={styles.costInputN}>
                  <div className={styles.impactHolder}>{conversionGain}</div>
                </div>
              </div>
              <div className={styles.costRow} style={hideCosts ? { height: "125px" } : {}}>
                <div className={styles.rowShort}>
                  <div className={styles.topLabel}>{falsePositiveLabel}</div>
                </div>
                <div className={styles.countInput} id="falsePositiveCount">
                  <LineInput
                    inputType="int"
                    value={falsePositive}
                    onChange={(val) => updateFalsePositive(val)}
                    borderColor={waterfallBars[1].color}
                    isBox
                    isLocked={isLocked}
                  />
                </div>
                {"×"}
                <div className={styles.costInputN}>
                  <div className={styles.impactHolder}>{conversionCost}</div>
                </div>
              </div>
              <div className={styles.costRow} style={hideCosts ? { height: "0px" } : {}}>
                <div className={styles.rowShort}>
                  <div className={styles.topLabel}>{trueNegativeLabel}</div>
                </div>
                <div className={styles.countInput} id="trueNegativeCount">
                  <LineInput
                    inputType="int"
                    value={trueNegative}
                    onChange={(val) => updateTrueNegative(val)}
                    borderColor={waterfallBars[hideCosts ? 0 : 2].color}
                    isBox
                    isLocked={isLocked}
                  />
                </div>
                {"×"}
                <div className={styles.costInputN}>
                  <div className={styles.impactHolder}>{conversionSaved}</div>
                </div>
              </div>
              <div className={styles.costRow} style={hideCosts ? { height: "0px" } : {}}>
                <div className={styles.rowShort}>
                  <div className={styles.topLabel}>{falseNegativeLabel}</div>
                </div>
                <div className={styles.countInput} id="falseNegativeCount">
                  <LineInput
                    inputType="int"
                    value={falseNegative}
                    onChange={(val) => updateFalseNegative(val)}
                    borderColor={waterfallBars[hideCosts ? 0 : 2].color}
                    isBox
                    isLocked={isLocked}
                  />
                </div>
                {"×"}
                <div className={styles.costInputN}>
                  <div className={styles.impactHolder}>{conversionMissed}</div>
                </div>
              </div>
              <div className={styles.costRow} style={hideCosts ? { height: "125px" } : {}}>
                <div className={styles.rowLabel + " " + styles.lFlex}>
                  <div className={styles.topLabel} style={{ width: "200px" }}>
                    <LineInput
                      value={netImpactLabel}
                      onChange={(val) => updateNetImpactLabel(val)}
                      isMediumBox
                      isLocked={isLocked}
                    />
                  </div>
                  <div className={styles.botLabel + " " + styles.centerLabelNoPad}>
                    {"Expected outcome of your current process per " + timePeriod}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
